import React, { useEffect, useState } from "react";
import BMInput from "../comps/BMInput";
import { Checkbox, Collapse, Button, Divider, Input, Space } from "antd";
import { Container, Draggable } from 'react-smooth-dnd';
import wrap from "../../utils/wrap"
import ImageSelect from "../ImageSelect";
import { TrashIcon, PlusIcon } from "../../admin/Icons";
import { HolderOutlined } from '@ant-design/icons';
import LinkUI from "./LinkUI";
import { makeKey } from "../../utils/Utils";
import RichTextEditor from "./RichTextEditor";
export default function Segments(props) {

    const {
        setData = () => { },
        data = {},
        paragraph_preset = 0,
        background_colour = 0,
        link_id = 0
    } = props;

    const [segments, setSegments] = useState(props.segments.map(item => {
        return { ...item, "id": makeKey() }
    }));
    const [selected, setSelected] = useState("");

    const save = () => {
        setData({ ...data, "segments": segments });
    }

    useEffect(save, [segments])

    const updateImage = (_key, _value, _index, _alt = "") => {
        let _arr = [...segments];
        _arr[_index][_key] = _value;
        if (_alt) {
            _arr[_index]["alt"] = _alt;
        }
        setSegments(_arr);
    }

    const removeImage = (_index) => {
        let _arr = [...segments];
        _arr.splice(_index, 1);
        setSegments(_arr);
        setSelected("");
    }

    const addImage = () => {
        let _arr = [...segments];
        _arr.push({
            path: "",
            alt: "",
            link: "",
            id : makeKey(),
            tab: false
        });
        // Set to newly created image
        setSelected(_arr.length - 1);
        setSegments(_arr);
    }

    const selectImage = (_index) => {
        if (selected === _index) {
            setSelected("")
        } else {
            setSelected(_index)
        }
    }

    const drawSegment = (_img = {}, _index) => {
        const { path = "", alt = "", link = "", tab = false, id = "" } = _img;

        return (
            <div key={_index}>
                {/* <ImageSelect require_alt alt={_img.alt} width={235} onChange={(_v, _a) => updateImage("path", _v, _index, _a)} path={path} />
                <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALT TEXT</Divider>
                <Input style={{ "fontSize": "11px" }} defaultValue={_img.alt} placeholder="Alt text.." onBlur={(e) => updateImage("alt", e.target.value, _index)} />
                <div className="shim" />
                <Divider style={{ "fontSize": "11px" }} orientationMargin={0} orientation="left" plain className="simple-divider">LINK</Divider>
                <LinkUI value={_img.link} onBlur={(e) => updateImage("link", e, _index)} />
                <div className="shim" />
                <div className="float-flex">
                    <div>&nbsp;</div>
                    <div><Checkbox checked={(_img.tab)} onChange={(e) => updateImage("tab", e.target.checked, _index)}><small>Open in new tab</small></Checkbox></div>
                </div> */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">NAME</Divider>
                <Input style={{ "fontSize": "11px" }} placeholder="Name..." defaultValue={_img.label} onBlur={(e) => updateImage("label", e.target.value, _index)} />
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                <Input style={{ "fontSize": "11px" }} placeholder="Headline..." defaultValue={_img.headline} onBlur={(e) => updateImage("headline", e.target.value, _index)} />
                <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                <RichTextEditor link_id={link_id} paragraph_preset={paragraph_preset} background_colour_default="#fff" background_colour={background_colour} onFinish={(e) => updateImage("paragraph", e, _index)} hold value={_img.paragraph} />
                <div className="shim" />


            </div>
        )
    }


    const ExpandDiv = (props) => {
        const { id = "", title = "", extra = "" } = props;
        const [expanded, setExpanded] = useState(id === selected)

        return (
            <div>
                <div className="float-flex">
                    <div onClick={() => setSelected((id === selected) ? "" : id)} style={{ "cursor": "pointer" }}><Space>{(expanded) ? "-" : "+"}{title}</Space></div>
                    <div>{extra}</div>
                </div>

                <div className="shim" />
                {(expanded && <div>{props.children}</div>)}
            </div>
        )
    }

    const drawSegments = () => {
        return segments.map((item, index) => {
            return (
                <Draggable key={item.id}>
                    <Space>
                        <div style={{ "cursor": "pointer" }} className="img_drag_handle">
                            {((selected !== item.id) && <HolderOutlined style={{ "fontSize": "14px", "opacity": "0.5" }} />)}
                        </div>
                        <div style={{ "width": (selected === item.id) ? "237px" : "223px" }}>
                            <ExpandDiv
                                id={item.id}
                                title={<><div style={{ "lineHeight": "10px" }}><wrap.tags small color="#e77e21">{(item.label) ? item.label : "Unnamed"} </wrap.tags></div></>}
                                extra={<><div style={{ "marginTop": "-2px" }}><Button onClick={() => removeImage(index)} type="link" icon={<TrashIcon />} size="small" /></div></>}
                            >
                                {drawSegment(item, index)}
                            </ExpandDiv>
                        </div>
                    </Space>
                </Draggable>
            )
        })
    }

    const onDrop = (dropResult) => {
        if (!dropResult.removedIndex && dropResult.removedIndex !== 0) return;

        const newItems = [...segments];
        newItems.splice(dropResult.addedIndex, 0, newItems.splice(dropResult.removedIndex, 1)[0]);
        console.log(newItems)
        setSegments(newItems);
    };

    return (
        <>
            <div className="float-flex">
                <div style={{ "width": "50px" }} orientationMargin={0} orientation="left" plain className="simple-divider ant-divider-with-text">SEGMENTS</div>
                <div style={{ "marginTop": "-5px" }}><Button onClick={() => addImage()} type="link" icon={<PlusIcon />} size="small" /></div>
            </div>
            <Divider style={{ "margin": "5px 0px" }} dashed />

            <Container dragHandleSelector=".img_drag_handle" lockAxis="y" onDrop={onDrop}>
                {drawSegments()}
            </Container>

        </>
    )
}